/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiWaveDecisionWinner } from '../models/ApiWaveDecisionWinner';
import { HttpFile } from '../http/http';

export class ApiWaveDecision {
    'decision_time': number;
    'winners': Array<ApiWaveDecisionWinner>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "decision_time",
            "baseName": "decision_time",
            "type": "number",
            "format": "int62"
        },
        {
            "name": "winners",
            "baseName": "winners",
            "type": "Array<ApiWaveDecisionWinner>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiWaveDecision.attributeTypeMap;
    }

    public constructor() {
    }
}

